import React,{useState} from 'react'
import data from  './projectdata.json'
import './master.css'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Heading from './assets/head2.png';

    
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: '#151515', 
  p: 4,
};


function ProjectCard() {
  const [open, setOpen] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [description, setDescription] = React.useState("");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  function handleModel(title,description){
    setTitle(title)
    setDescription(description)
    handleOpen()
  }
  return (
    <div className=" container flex justify-center items-center flex-wrap md:flex-row flex-col">
     
      {/* Intro */}
      {/* <div className={`container w-[100%] h-auto flex-grow border-8 border-iemctred p-10 overflow-hidden text-center pt-10 lg:text-7xl sm:text-6xl text-5xl font-raleway font-semibold bg-backcol text-iemctred`}>
      {'<<<'} From Concepts to Completion.
      <br/> 
      It's a Vision {'>>>'} 
     
    </div> */}
    <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className='border-2 border-iemctred shadow-md duration-200 sm:w-3/4 w-[75%] sm:h-auto h-[75%] overflow-auto text-gray-300 rounded-md'>
          {/* logo */}
          <div className='flex justify-center'>
      <img src={Heading} alt="IEMCT_Logo" className='p-0 h-20 -my-4 pb-5 mb-auto pt-2' />
      </div>
          <div className='text-gray-300 font-custom text-3xl my-2' >
            {title}
          </div>
          <div className='text-gray-400 text-xl font-raleway'>
            {description}
          </div>
        </Box>
      </Modal>

      
      {/* Cards */}
      { data.map((info)=>(
        
         <div className={`text-iemctwhite lg:w-1/4 sm:w-1/2 w-[95%] grow-0 h-[35rem] border-[5px] border-iemctred border-double rounded-lg my-4 mx-2 overflow-auto text-[2vh] bg-backcol relative cursor-pointer hover:-translate-y-2 `} id="ProjectCards" key={info.id}>
          

               <img src={info.image} alt="..." className=' image-cover h-[12rem] w-[80%] m-auto my-5 rounded-md' />
          
       <div className={`text-white px-5 py-2 bg-backcol`} >
        <div className='text-[3vh] mb-5 text-transparent font-raleway font-bold bg-clip-text bg-gradient-to-b from-iemctred from-20% to-iemctredhov to-80% mt-4 border-4 border-iemctred rounded-md'>
        {info.name}
        </div>
       
       </div>
       <div className={` w-full h-auto p-1 mb-8 flex justify-center  text-iemctwhite mt-4 bg-backcol border-y-4 border-iemctred py-2 rounded-md text-md`}>
        {info.creators}
       </div>
       <div className=' flex justify-center' id='fingerprint'>
      <button onClick={()=>{handleModel(info.name, info.description)}} >
       <svg width="50px" height="50px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.10008 21.221C6.71021 19.2375 5.89258 16.8243 5.89258 14.2187C5.89258 10.8443 8.6265 8.10938 11.9989 8.10938C15.3712 8.10938 18.1051 10.8443 18.1051 14.2187" stroke="#BD5868" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M8.10008 21.221C6.71021 19.2375 5.89258 16.8243 5.89258 14.2187C5.89258 10.8443 8.6265 8.10938 11.9989 8.10938C15.3712 8.10938 18.1051 10.8443 18.1051 14.2187" stroke="#BD5868" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M18.4361 20.3118C18.3262 20.3179 18.2182 20.3281 18.1073 20.3281C14.7349 20.3281 12.001 17.5931 12.001 14.2188" stroke="#BD5868" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M18.4361 20.3118C18.3262 20.3179 18.2182 20.3281 18.1073 20.3281C14.7349 20.3281 12.001 17.5931 12.001 14.2188" stroke="#BD5868" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.2694 21.9999C10.675 20.382 8.94705 17.5024 8.94705 14.2187C8.94705 12.5315 10.3145 11.164 12.0007 11.164C13.6869 11.164 15.0543 12.5315 15.0543 14.2187C15.0543 15.9059 16.4218 17.2733 18.108 17.2733C19.7942 17.2733 21.1616 15.9059 21.1616 14.2187C21.1616 9.1571 17.0602 5.05469 12.0017 5.05469C6.94319 5.05469 2.8418 9.1571 2.8418 14.2187C2.8418 15.3469 2.96806 16.4455 3.20021 17.5045" stroke="#BD5868" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.2694 21.9999C10.675 20.382 8.94705 17.5024 8.94705 14.2187C8.94705 12.5315 10.3145 11.164 12.0007 11.164C13.6869 11.164 15.0543 12.5315 15.0543 14.2187C15.0543 15.9059 16.4218 17.2733 18.108 17.2733C19.7942 17.2733 21.1616 15.9059 21.1616 14.2187C21.1616 9.1571 17.0602 5.05469 12.0017 5.05469C6.94319 5.05469 2.8418 9.1571 2.8418 14.2187C2.8418 15.3469 2.96806 16.4455 3.20021 17.5045" stroke="#BD5868" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20.5257 5.86313C18.4435 3.4978 15.399 2 12.0002 2C8.60136 2 5.55687 3.4978 3.47461 5.86313" stroke="#BD5868" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20.5257 5.86313C18.4435 3.4978 15.399 2 12.0002 2C8.60136 2 5.55687 3.4978 3.47461 5.86313" stroke="#BD5868" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
       </button>
       </div>
       
       
       </div>  
       
      ))
   
      }
   
    </div>
  )
}

export default ProjectCard
